import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=046aef7b&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=046aef7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046aef7b",
  null
  
)

export default component.exports